import { render, staticRenderFns } from "./TagItem.vue?vue&type=template&id=7b237267&scoped=true&"
import script from "./TagItem.vue?vue&type=script&lang=ts&"
export * from "./TagItem.vue?vue&type=script&lang=ts&"
import style0 from "./TagItem.vue?vue&type=style&index=0&id=7b237267&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b237267",
  null
  
)

export default component.exports